import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Button } from '@mui/material';
import { useServicesDestroyMutation } from '../../../../services/GLOWClient';
import MuiDialog from '../../../../SystemDesign/MuiDialog';
import DeleteIcon from '@mui/icons-material/Delete';

const DeleteService = ({ open, onClose, onSuccess, serviceId, serviceName, serviceData }) => {
    const { t } = useTranslation();
    const [deleteService, { isLoading }] = useServicesDestroyMutation();
    
    const handleDelete = async () => {
        const inferredId = serviceId ?? serviceData?.id ?? serviceData?.service_id ?? serviceData?.pk ?? null;
        const inferredName = serviceName ?? serviceData?.name ?? '';

        if (!inferredId) {
            console.warn('DeleteService: No serviceId provided, aborting delete. Props:', { serviceId, serviceName, serviceData });
            return;
        }
        
        try {
            console.log('Deleting service with ID:', inferredId);
            const result = await deleteService({ serviceId: inferredId }).unwrap();
            console.log('Service deleted successfully:', result);
            
            // Call success callback with the deleted service data
            const deletedService = {
                id: inferredId,
                name: inferredName
            };
            
            // Close dialog first
            onClose();
            
            // Then call success callback to show notification
            if (onSuccess) {
                onSuccess(deletedService);
            }
        } catch (error) {
            console.error('Failed to delete service:', error);
            console.error('Error details:', error.data);
            
            // Close dialog
            onClose();
            
            // Call onSuccess with error to display notification
            if (onSuccess) {
                onSuccess(null, error);
            }
        }
    };
    
    // Dialog content
    const content = (
        <>
            <Typography variant="body1" gutterBottom>
                {t('pro_service.delete_service.confirm_message', { name: serviceName || serviceData?.name || '' })}
            </Typography>
            <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                {t('pro_service.delete_service.irreversible_warning')}
            </Typography>
        </>
    );
    
    // Trigger button for the dialog - this is hidden as we're controlling the dialog externally
    const triggerButton = <Button style={{ display: 'none' }}>Open</Button>;
    
    return (
        <MuiDialog
            open={open}
            icon={<DeleteIcon />}
            triggerButton={triggerButton}
            title={t('pro_service.delete_service.delete_service_title')}
            subtitle={t('pro_service.delete_service.delete_service_subtitle')}
            content={content}
            existAction={true}
            actionTitle={t('pro_service.delete_service.delete')}
            actionFunction={handleDelete}
            onExternalClose={onClose}
            isLoading={isLoading}
            actionType="button"
            maxWidth="xs"
            disableAction={isLoading}
            actionColor="error"
        />
    );
};

export default DeleteService;